module.exports = __webpack_public_path__ + "img/2354967276de4346f8e0c894181efcfc.png";